export default {
  common: {
    next: 'Continue',
    back: 'Back',
    submit: 'Submit',
    cancel: 'Cancel',
    yes: 'YES',
    no: 'NO',
    required: '*',
    loading: 'Loading...',
    verifying: 'Verifying...',
    submitting: 'Submitting...',
    startingForm: 'Starting form...',
    startRegistration: 'Start Registration',
    selectCountry: 'Select country',
    other: 'Other',
    specify: 'Please specify',
    note: 'Note',
    instructions: 'Instructions',
    securityNotice: 'Security Notice',
    importantInfo: 'Important Information'
  },
  
  nav: {
    home: 'Home'
  },
  
  home: {
    title: 'Registration and AML Questionnaire',
    subtitle: 'Complete the AML questionnaire for client identification and verification in accordance with Act No. 253/2008 Coll., on certain measures against money laundering and terrorist financing.',
    legalEntity: 'Legal Entity',
    legalEntityDesc: 'Form for companies, corporations, and other legal entities',
    physicalPerson: 'Natural Person',
    physicalPersonDesc: 'Form for individuals and natural persons',
    importantInfoTitle: 'Important Information',
    importantInfo1: 'All data is securely encrypted',
    importantInfo2: 'Make sure you have all required documents ready (ID card, driver\'s license, passport if applicable)',
    sessionError: 'Failed to create session. Please refresh the page and try again.',
    captchaError: 'Captcha verification failed. Please refresh the page and try again.',
    verifyFirst: 'Please complete the verification that you are not a robot first.'
  },
  
  success: {
    title: 'Form Successfully Submitted!',
    subtitle: 'Thank you for completing the AML questionnaire. Your data has been securely submitted and processed.',
    submissionDetails: 'Submission Details',
    formType: 'Form Type',
    submissionId: 'Submission ID',
    submissionTime: 'Submission Time',
    legalEntityLabel: 'Legal Entity',
    physicalPersonLabel: 'Natural Person',
    nextStepsTitle: 'What happens next?',
    nextStep1: 'Your data has been submitted for further processing',
    nextStep2: 'All data is securely encrypted',
    nextStep3: 'We will contact you using the provided contact information',
    nextStep4: 'The entered data has been automatically deleted from your browser, you can now close this page',
    newForm: 'Fill out a new form',
    contactUs: 'If you have questions, contact us at:'
  },
  
  notFound: {
    title: 'Page Not Found',
    message: 'The requested page does not exist.',
    backHome: 'Back to Home'
  },
  
  draftRecovery: {
    title: 'Draft Found',
    message: 'You have a draft for',
    legalEntityLabel: 'Legal Entity',
    physicalPersonLabel: 'Natural Person',
    question: 'What would you like to do?',
    continueDraft: 'Continue with the draft',
    startNew: 'Start over (deletes the draft)'
  },
  
  validation: {
    fillAllFields: 'Please fill in all required fields',
    invalidEmail: 'Please enter a valid email address',
    uploadAllDocuments: 'Please upload all 4 document pages (2 documents × 2 sides)',
    selectTwoDocuments: 'You must select exactly 2 document types',
    icoLength: 'The identification number must have 8 digits'
  },
  
  documents: {
    title: 'Identity Documents',
    selectTwoTypes: 'Select 2 types of identity documents',
    idCard: 'ID Card',
    driverLicense: 'Driver\'s License',
    passport: 'Passport',
    frontSide: 'Front side',
    backSide: 'Back side',
    uploadInstructions: 'Select 2 of 3 available document types. For each document, upload 2 photos - front and back side.',
    securityNotice: 'These documents contain sensitive personal data. Files will be securely encrypted before sending and automatically deleted from your device after successful form submission.',
    requirements: {
      imagesOnly: 'Images only (JPG, PNG)',
      maxSize: 'Maximum size: 10MB',
      readable: 'Document must be clearly readable'
    }
  },
  
  fileUpload: {
    allowedFormats: 'Allowed formats: PDF, DOC, DOCX, XLS, XLSX, PNG, JPG, JPEG',
    maxSize: 'Maximum file size: 10MB',
    companyDocReq: 'Legal entity must provide proof of existence (extract from commercial register, etc.)'
  },
  
  physicalPerson: {
    step1: {
      title: 'STEP 1 - Client Identification Data',
      firstName: 'First Name',
      lastName: 'Last Name',
      birthNumber: 'Birth Number (if not available, enter date of birth)',
      birthNumberPlaceholder: '123456/7890 or DD.MM.YYYY',
      birthPlace: 'Place of Birth (city and country)',
      birthPlacePlaceholder: 'Prague, Czech Republic',
      address: 'Permanent or Other Residence / Registered Office',
      addressPlaceholder: 'Enter address',
      citizenship: 'Citizenship',
      citizenshipPlaceholder: 'Czech Republic',
      phone: 'Phone',
      phonePlaceholder: '+420 123 456 789',
      email: 'Email',
      emailPlaceholder: 'email@yourcompany.com',
      taxResidence: 'Tax Residence',
      taxResidencePlaceholder: 'CZ',
      identityDocumentsTitle: 'Identity documents of the natural person (client)'
    },
    step2: {
      title: 'STEP 2 - Client Representation',
      hasRepresentative: 'Is the client represented?',
      representativeNote: '(person acting on behalf of the client in the transaction)',
      noRepresentativeInfo: 'The client will not be represented. Please continue to step 4.',
      hasRepresentativeInfo: 'The client will be represented. In the next step, you will fill in the representative\'s details.'
    },
    step3: {
      title: 'STEP 3 - Representative Details',
      skipNotice: 'This step is skipped because the client will not be represented.',
      continueToStep4: 'Continue to step 4',
      representationType: 'Type of Representation',
      nameLabel: 'Full Name / Company / Name',
      namePlaceholder: 'Enter full name or company name',
      gender: 'Gender',
      taxResidenceNote: 'If no country is specified, the client declares that they are a tax resident only of the country in which their permanent residence is located. In general, for determining the client\'s tax residence, the rule applies that they are a tax resident of the country in which they stay for at least 183 days per year, unless that country sets different rules for determining tax residence.',
      guardianNote: '(The guardian is obliged to present the relevant court decision.)',
      identityDocumentsTitle: 'Identity documents of the natural person\'s representative'
    },
    step4: {
      title: 'STEP 4 - Client Verification - Income Sources',
      incomeSource: 'Income Sources',
      otherIncomeSource: 'Specify other income source',
      otherIncomePlaceholder: 'Enter other income source',
      incomeNature: 'Nature of Primary Income Source (Industry)',
      incomeNaturePlaceholder: 'e.g. IT services, trade, manufacturing...',
      annualIncome: 'Net Annual Income / Annual Turnover',
      annualIncomePlaceholder: 'Enter annual income/turnover',
      incomeSourceNature: 'Nature of Primary Income Source',
      incomeSourceNaturePlaceholder: 'Detailed description of the nature of primary income source',
      netAnnualIncome: 'Net Annual Income',
      netAnnualIncomePlaceholder: 'Enter net annual income'
    },
    step5: {
      title: 'STEP 5 - Expected Transactions',
      monthlyVolume: 'Expected Monthly Transaction Volume',
      monthlyVolumePlaceholder: 'Enter expected monthly transaction volume',
      paymentPurpose: 'Expected Payment Purpose',
      paymentPurposePlaceholder: 'Enter expected payment purpose',
      transactionType: 'Most Common Type of Withdrawal Transactions',
      transactionTypePlaceholder: 'Enter most common type of withdrawal transactions'
    },
    step6: {
      title: 'STEP 6 - Politically Exposed Person and International Sanctions',
      isPEP: 'Are you a politically exposed person?',
      pepDetails: 'Please specify',
      pepDetailsPlaceholder: 'Specify function or position',
      pepNote: 'a) a natural person who holds or has held a significant public function of national or regional importance, such as head of state, prime minister, head of a central government authority and their deputy (deputy, state secretary), member of parliament, member of the governing body of a political party, leading representative of regional self-government (mayor, governor), judge of the supreme court, constitutional court or other supreme judicial body, against whose decision generally no remedies can be used except in exceptional cases, member of the board of the central bank, senior officer of the armed forces or corps, member or representative of a member, if it is a legal entity, of the statutory body of a state-controlled business corporation, ambassador or head of a diplomatic mission, or a natural person who performs or has performed a similar function in another state, in a body of the European Union or in an international organization.',
      isSanctioned: 'Are you subject to sanctions of the Czech Republic or international sanctions',
      sanctionDetails: 'Please specify',
      sanctionDetailsPlaceholder: 'Specify type and scope of sanctions',
      sanctionNote: 'According to Act No. 69/2006 Coll. on international sanctions, international sanctions mean an order, prohibition or restriction established for the purpose of maintaining or restoring international peace and security, combating terrorism, observing international law, protecting human rights and freedoms, and supporting democracy and the rule of law.'
    },
    step7: {
      title: 'STEP 7 - Submission and Signature',
      legalNotice: 'The client acknowledges and by signing this document agrees that the Company processes the client\'s personal data to the extent necessary for exercising rights and fulfilling obligations arising from applicable legal regulations and contractual arrangements, including for the purpose of identifying and verifying the client in accordance with Act No. 253/2008 Coll. on certain measures against money laundering and terrorist financing.',
      clientStatement: 'Client Statement:',
      clientStatementText: 'I confirm that all the above information is complete and true, that I have not withheld any important information that is or may be known to me, and I undertake to report any changes to the Company without undue delay.',
      signature: 'Client Signature (enter full name)',
      signaturePlaceholder: 'Enter your full name as an electronic signature',
      signatureNote: 'By entering your full name, you confirm the accuracy of all provided information',
      finalConfirmation: 'I confirm that I have read and agree to all the stated conditions and that all provided information is true and complete.',
      dataProcessingNotice: 'Data Processing Information:',
      dataProcessingText: 'Your data will be securely encrypted before being sent to our server. After successful submission, all local data will be automatically deleted from your device.',
      submitButton: 'SUBMIT NATURAL PERSON REGISTRATION'
    }
  },
  
  legalEntity: {
    step1: {
      title: 'STEP 1 - Client Identification Data',
      companyDocumentsLabel: 'Company / Other Legal Form Name (including distinguishing addition or other designation)',
      companyName: 'Company Name',
      companyNamePlaceholder: 'Enter company name',
      address: 'Registered Office / Place of Business',
      addressPlaceholder: 'Enter company address',
      ico: 'Identification Number (IČO)',
      icoPlaceholder: 'Enter IČO',
      dic: 'Tax Identification Number (DIČ)',
      dicPlaceholder: 'Enter DIČ (optional)',
      taxResidence: 'Tax Residence',
      registryInfo: 'Registry Entry Information',
      registryInfoPlaceholder: 'Enter registry entry information',
      actualOwner: 'Beneficial Owner',
      actualOwnerPlaceholder: 'According to § 4 para. 4 of Act No. 253/2008 Coll. on certain measures against money laundering and terrorist financing, as amended',
      phone: 'Phone',
      phonePlaceholder: '+420 123 456 789',
      email: 'Email',
      emailPlaceholder: 'email@yourcompany.com'
    },
    step2: {
      title: 'STEP 2 - Details of the Natural Person Authorized to Act on Behalf of the Client - Legal Entity',
      note: 'If a natural person acts on behalf of a legal entity based on a power of attorney, they are obliged to present this written power of attorney. If acting as an employee, the natural person must present an employment contract and authorization entitling them to act on behalf of the legal entity. If the legal entity has other representation, the relevant court decision or other document on the basis of which this natural person acts must be presented.',
      representation: 'Representation by Statutory Body',
      representationPlaceholder: 'Select type of representation',
      firstName: 'First Name',
      firstNamePlaceholder: 'Enter first name',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Enter last name',
      birthNumber: 'Birth Number (if not available, enter date of birth)',
      birthNumberPlaceholder: '123456/7890 or DD.MM.YYYY',
      birthPlace: 'Place of Birth (city and country)',
      birthPlacePlaceholder: 'Prague, Czech Republic',
      address: 'Permanent or Other Residence / Registered Office',
      addressPlaceholder: 'Enter address',
      gender: 'Gender',
      citizenship: 'Citizenship',
      citizenshipPlaceholder: 'Czech Republic',
      phone: 'Phone',
      phonePlaceholder: '+420 123 456 789',
      email: 'Email',
      emailPlaceholder: 'email@yourcompany.com',
      taxResidence: 'Tax Residence',
      taxResidencePlaceholder: 'Czech Republic',
      isPEP: 'Are you a politically exposed person?',
      pepDetails: 'Please specify',
      pepDetailsPlaceholder: 'Specify function or position',
      pepNote: 'A politically exposed person is a natural person who holds or has held a significant public function of national or regional importance...',
      isSanctioned: 'Are you subject to sanctions of the Czech Republic or international sanctions',
      sanctionDetails: 'Please specify',
      sanctionDetailsPlaceholder: 'Specify type and scope of sanctions'
    },
    step3: {
      title: 'STEP 3 - Verification of Identity Documents of the Natural Person Authorized to Act on Behalf of the Client',
      instructions: 'Select 2 of 3 available document types. For each document, upload 2 photos - front and back side.',
      selectDocuments: 'Select 2 types of identity documents',
      securityNotice: 'These documents contain sensitive personal data. Files will be securely encrypted before sending and automatically deleted from your device after successful form submission.'
    },
    step4: {
      title: 'STEP 4 - Client Verification',
      incomeSource: 'Income Sources',
      otherIncomeSource: 'Specify other income source',
      otherIncomePlaceholder: 'Enter other income source',
      incomeNature: 'Nature of Primary Income Source (Industry)',
      incomeNaturePlaceholder: 'e.g. IT services, trade, manufacturing...',
      annualIncome: 'Net Annual Income / Annual Turnover',
      annualIncomePlaceholder: 'Enter annual income/turnover'
    },
    step5: {
      title: 'STEP 5 - Expected Transactions',
      monthlyVolume: 'Expected Monthly Transaction Volume',
      monthlyVolumePlaceholder: 'Enter expected monthly transaction volume',
      paymentPurpose: 'Expected Payment Purpose',
      paymentPurposePlaceholder: 'Enter expected payment purpose',
      transactionType: 'Most Common Type of Withdrawal Transactions',
      transactionTypePlaceholder: 'Enter most common type of withdrawal transactions'
    },
    step6: {
      title: 'STEP 6 - Submission and Signature',
      noteTitle: 'Note:',
      legalNotice: 'The client acknowledges and by signing this document agrees that the Company processes the client\'s personal data to the extent necessary for exercising rights and fulfilling obligations arising from applicable legal regulations and contractual arrangements, including for the purpose of identifying and verifying the client in accordance with Act No. 253/2008 Coll. on certain measures against money laundering and terrorist financing.',
      clientStatement: 'Client Statement:',
      clientStatementText: 'I confirm that all the above information is complete and true, that I have not withheld any important information that is or may be known to me, and I undertake to report any changes to the Company without undue delay.',
      signature: 'Client Signature (enter full name)',
      signaturePlaceholder: 'Enter your full name as an electronic signature',
      signatureNote: 'By entering your full name, you confirm the accuracy of all provided information',
      finalConfirmation: 'I confirm that I have read and agree to all the stated conditions and that all provided information is true and complete.',
      dataProcessingNotice: 'Data Processing Information:',
      dataProcessingText: 'Your data will be securely encrypted before being sent to our server. After successful submission, all local data will be automatically deleted from your device.',
      submitButton: 'SUBMIT LEGAL ENTITY REGISTRATION'
    }
  },
  
  options: {
    representationType: {
      statutory: 'By statutory body',
      powerOfAttorney: 'Based on power of attorney',
      legalGuardian: 'By legal guardian',
      guardian: 'By guardian'
    },
    legalRepresentationType: {
      powerOfAttorney: 'Based on power of attorney',
      employee: 'As employee',
      other: 'Other representation'
    },
    gender: {
      male: 'Male',
      female: 'Female',
      other: 'Other'
    },
    incomeSource: {
      employee: 'Employee',
      entrepreneur: 'Entrepreneur',
      other: 'Other (please specify)'
    }
  },
  
  countries: {
    czechRepublic: 'Czech Republic',
    slovakRepublic: 'Slovak Republic',
    poland: 'Poland',
    otherCountries: 'Other Countries'
  }
}
